import { ViewStackViewUnencapsulatedComponent } from './view-stack-view-unencapsulated/view-stack-view-unencapsulated.component';
import {
  Component,
  OnInit,
  AfterContentInit,
  ContentChildren,
  QueryList,
  Directive,
  ElementRef,
  Output,
  EventEmitter,
  Input
} from '@angular/core';
import { ViewStackViewComponent } from './view-stack-view/view-stack-view.component';



@Component({
  selector: 'app-view-stack',
  templateUrl: './view-stack.component.html',
  styleUrls: ['./view-stack.component.scss']
})

export class ViewStackComponent implements OnInit, AfterContentInit {


  @ContentChildren(ViewStackViewComponent, { descendants: false }) encapsChildren !: QueryList<ViewStackViewComponent>;
  @ContentChildren(ViewStackViewUnencapsulatedComponent, { descendants: false }) unencapsChildren !: QueryList<ViewStackViewUnencapsulatedComponent>;
  public get children(): {[key:string] : ViewStackViewComponent } {
    return this.childMap
  }
  @Output() ready = new EventEmitter<any>();
  private childMap: {[key:string] :ViewStackViewComponent | ViewStackViewUnencapsulatedComponent } = {};
  private displayedView = '';
  public value: any;
  get selectedView(): string {
    return this.displayedView;
  }
  @Input()
  set viewName(name: string) {
    this.SetView(name);
  }
  @Output() viewNameChange: EventEmitter<string> = new EventEmitter<string>();

  get currentView(): ViewStackViewComponent {
    return this.childMap[this.displayedView];
  }
  get element(): ElementRef {
    return this.domNode;
  }


  constructor(private domNode: ElementRef) { }

  ngOnInit() {
    $(this.domNode.nativeElement).toggleClass('view-stack', true);
  }
  ngAfterContentInit() {
    let isFirst = true;
    let firstChild: ViewStackViewComponent = null;
    let initView: string = this.displayedView;

    this.encapsChildren.forEach((child: ViewStackViewComponent, index: number, src: ViewStackViewComponent[]) => {
      if (isFirst) {
        firstChild = child;
        if (initView === '') {
          initView = (!!firstChild) ? firstChild.viewName : '';
        }
      }
      child.ToggleActive(child.viewName === initView);

      isFirst = false;
      this.childMap[child.viewName] = child;

    });
    this.unencapsChildren.forEach((child: ViewStackViewComponent, index: number, src: ViewStackViewComponent[]) => {
      if (isFirst) {
        firstChild = child;
        if (initView === '') {
          initView = (!!firstChild) ? firstChild.viewName : '';
        }
      }
      child.ToggleActive(child.viewName === initView);

      isFirst = false;
      this.childMap[child.viewName] = child;

    });
    if (firstChild !== null) {
      this.SetView(initView);
    }
    this.ready.emit(this);

    /*if (this.selectedView) {
      this.SetView(this.selectedView);
    }*/
  }
  SetView(viewName: string) {
    if (viewName === '') {
      viewName = 'none';
    }
    if (viewName === 'none') {
      if (this.displayedView) {
        (this.childMap[this.displayedView] as ViewStackViewComponent).ToggleActive(false);
      }
      $(this.domNode.nativeElement).toggleClass('hidden', true);
      return;
    }
    $(this.domNode.nativeElement).toggleClass('hidden', false);
    if (!this.childMap.hasOwnProperty(viewName)) {
      // this.displayedView = viewName;
      return;
    }
    if (this.displayedView) {
      (this.childMap[this.displayedView] as ViewStackViewComponent).ToggleActive(false);
    }
    this.displayedView = viewName;
    (this.childMap[viewName] as ViewStackViewComponent).ToggleActive(true);

    this.viewNameChange.emit(this.displayedView);

  }
}
